import { buildAction } from 'store/actions/actionCreator'

import { FETCH_SALE_TYPES } from './constants'

export const fetchSaleTypes = buildAction(FETCH_SALE_TYPES, 'payload')
